import { api } from '../api';
import { btn, field, text } from '../ui';
import TeamPanel from './TeamPanel';

export default function SettingsTab({
  isAuthenticated,
  onLogin,
  calendars,
  setCalendars,
  ptoCalendarIds,
  setPtoCalendarIds,
  targetCalendarId,
  setTargetCalendarId,
  emailToName,
  onSave,
  onCancel,
  onSaveTeam,
  syncStatus,
  showNotice,
  roster,
  zoneNames,
  clrRoster,
}) {
  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">Google Calendar Settings</h2>
  
      {!isAuthenticated ? (
        <div className="p-4 bg-yellow-50 rounded mb-4">
          <p className="text-sm">Connect to Google Calendar to enable sync features.</p>
          <button onClick={onLogin} className="mt-2 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
            Connect Google Calendar
          </button>
        </div>
      ) : (
        <div className="space-y-6">
          {calendars.length === 0 && (
            <div className="p-4 bg-blue-50 rounded">
              <p className="text-sm text-blue-900 mb-2">No calendars loaded. Click below to load your calendars.</p>
              <button 
                onClick={async () => {
                  try {
                    const { ok, data } = await api.listCalendars();
                    if (ok) {
                      setCalendars(data.calendars || []);
                    } else {
                      showNotice('error', 'Failed to load calendars', [data?.error || 'Unknown error']);
                    }
                  } catch (err) {
                    showNotice('error', 'Error loading calendars', [err.message]);
                  }
                }}
                className={btn.primary}
              >
                Load Calendars
              </button>
            </div>
          )}
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className={field.label}>PTO Calendars (select multiple)</label>
              <div className="border rounded px-3 py-2 max-h-48 overflow-y-auto">
                {calendars.length === 0 ? (
                  <p className="text-sm text-gray-500">No calendars loaded</p>
                ) : (
                  calendars.map(cal => (
                    <label key={cal.id} className="flex items-center py-1 hover:bg-gray-50 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={ptoCalendarIds.includes(cal.id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setPtoCalendarIds([...ptoCalendarIds, cal.id]);
                          } else {
                            setPtoCalendarIds(ptoCalendarIds.filter(id => id !== cal.id));
                          }
                        }}
                        className="mr-2"
                      />
                      <span className="text-sm">{cal.summary}</span>
                    </label>
                  ))
                )}
              </div>
              <p className={text.hintTight}>PTO events will be imported from all selected calendars</p>
            </div>
        
            <div>
              <label className={field.label}>Target Calendar (write SLR + CLR)</label>
              <select
                value={targetCalendarId}
                onChange={(e) => setTargetCalendarId(e.target.value)}
                className="w-full border rounded px-3 py-2"
              >
                <option value="">Select calendar...</option>
                {calendars.map(cal => (
                  <option key={cal.id} value={cal.id}>{cal.summary}</option>
                ))}
              </select>
              <p className={text.hintTight}>Both SLR and CLR schedules will be synced to this calendar</p>
            </div>
          </div>

          <div>
            <button onClick={onSave} className={btn.saveLg}>Save calendar settings</button>
            <button onClick={onCancel} className={`${btn.cancel} ml-2`}>Cancel</button>
            {syncStatus && <p className="text-sm text-gray-600 mt-2">{syncStatus}</p>}
          </div>

          <div className="border-t pt-6">
            <TeamPanel
              emailToName={emailToName}
              roster={roster}
              zoneNames={zoneNames}
              clrRoster={clrRoster}
              onSave={onSaveTeam}
            />
          </div>
        </div>
      )}
    </div>
  );
}
